function Gallery(props) {
  return (
    <section className="gallery">
      <h2><span className="purple">New</span> Releases</h2>
      <p>Give a try to the newly released movies to kill your time!</p>
      <div className="movie-list flex">
        {props.list.map(movie => (
          <div key={movie.id}>
            <div className="poster-img">
              <img src={movie.poster} className="movie-poster" alt={movie.title} />
            </div>
            <p>{movie.title}</p>
          </div>
        ))}
    </div>
    </section>
  );
}

export default Gallery;